<template>
</template>

<script>
import actions from "../../vuex/action_types";
import store from "../../vuex/store";
import events from "../../services/Events";

export default {
    name: "ModalDataLoader",
    props: {
        operations: {
            required: true,
        },
    },
    mounted: function () {
        let operationsIds = Object.values(this.operations).map(operation => {
          return operation.id
        });
        this.$store.dispatch(actions.FETCH_SELECT2_CONTRACTORS_LIST);
        this.$store.dispatch(actions.PREPARE_DEPARTMENT_TRANSFERS_DATA, {
            operations: JSON.stringify(operationsIds)
        }).then(() => {
            events.$emit('modalDataLoaded')
        });
    },
    store
}
</script>

<style scoped>

</style>